module.exports = __webpack_public_path__ + "static/media/dana5.4b47c0c6.jpg";